(function () {
  const STORAGE_KEY = 'santo:visitor-country';
  const STORAGE_TTL_MS = 24 * 60 * 60 * 1000;

  function getCachedCountry() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const { code, t } = JSON.parse(raw);
      if (!code || !t) return null;
      if (Date.now() - t > STORAGE_TTL_MS) return null;
      return code;
    } catch {
      return null;
    }
  }

  function setCachedCountry(code) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ code, t: Date.now() }));
    } catch {}
  }

  async function detectCountry() {
    const cached = getCachedCountry();
    if (cached) return cached;
    try {
      const res = await fetch('https://api.country.is/', { cache: 'no-store' });
      if (!res.ok) throw new Error(`country.is ${res.status}`);
      const json = await res.json();
      const code = (json.country || '').toUpperCase();
      if (code) setCachedCountry(code);
      return code;
    } catch (err) {
      console.warn('Country detection failed', err);
      return null;
    }
  }

  function applyVisibility(country) {
    const bars = document.querySelectorAll('[data-free-shipping-country]');
    bars.forEach((bar) => {
      const required = (bar.dataset.freeShippingCountry || '').toUpperCase();
      if (!required) {
        bar.hidden = false;
        return;
      }
      bar.hidden = country !== required;
    });
  }

  let currentCountry = null;

  async function init() {
    currentCountry = await detectCountry();
    applyVisibility(currentCountry);
  }

  function reapply() {
    if (currentCountry !== null) {
      applyVisibility(currentCountry);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-apply when new bars appear in the DOM (e.g., after cart-drawer refreshContents)
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('[data-free-shipping-country]') || node.querySelector?.('[data-free-shipping-country]')) {
          reapply();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
